/**
 * --------------------------------------------------
 * Navigation Module
 *
 * @module Navigation
 * --------------------------------------------------
 */

export default {
    _$app: null,
    _$menuItem: null,
    _activeClass: 'submenu-open',
    _overlayClass: 'overlay',
    _$hamburger_menu: null,
    _$menu: null,
    _$header: null,

    setup() {
        this._$app = $('body');
        // target the exact menu
        this._$menuItem = $('#rt-header__nav > li.menu-item-has-children');
        this._$hamburger_menu = $('.rt-js-hamburger');
        this._$menu = $('#rt-header__nav');
        this._$header = $('.rt-header');
        this._updateMobileMenuOffset();
        this.listeners();
    },

    listeners() {
        this._$menuItem
        .on('mouseenter', e => this._open($(e.currentTarget)))
        .on('mouseleave', e => this._close($(e.currentTarget)))
        .on('focusin',   e => this._open($(e.currentTarget)))
        .on('focusout',  e => {
            // close when focus leaves the whole li (not just the link)
            if (!$(e.currentTarget).has(document.activeElement).length) {
                this._close($(e.currentTarget));
            }
      });

      // Hamburger menu toggle
      this._$hamburger_menu.on('click', e => {
            e.preventDefault();

            const $icon = this._$hamburger_menu.find('img');
            const defaultSrc = '/wp-content/themes/rithum/images/global/open-menu.svg';
            const activeSrc = '/wp-content/themes/rithum/images/global/close-menu.svg';

            if(this._$menu.hasClass('closed')) {
                this._showMobileMenu();
                $icon.attr('src', activeSrc);

            } else if(!this._$menu.hasClass('closed')) {
                this._hideMobileMenu();
                $icon.attr('src', defaultSrc);
            }
        });

        $(window).on('resize orientationchange', () => {
            this._updateMobileMenuOffset();
        });

        $(window).on('load', () => {
            this._updateMobileMenuOffset();
        });
  },

    _open($el) {
        this._$menuItem.removeClass(this._activeClass);
        $el.addClass(this._activeClass);
        if ($el.closest('ul.js-has-overlay').length) this._showOverlay();
    },

    _close($el) {
        $el.removeClass(this._activeClass);
        if (!this._$menuItem.filter('.' + this._activeClass).length) this._hideOverlay();
    },

    _showOverlay() { 
        this._$app.addClass(this._overlayClass); 
    },

    _hideOverlay() { 
        this._$app.removeClass(this._overlayClass);
    },

    _showMobileMenu() {
        this._updateMobileMenuOffset();
        this._$menu.removeClass('closed');
        this._$app.addClass('menu-open');
    },

    _hideMobileMenu() {
        this._$menu.addClass('closed');
        this._$app.removeClass('menu-open');
    },

    _updateMobileMenuOffset() {
        const headerHeight = Math.ceil(this._$header.outerHeight() || 90);
        document.documentElement.style.setProperty('--rt-mobile-nav-top', `${headerHeight}px`);
    },
};